/**
 * Created by gilk on 10/08/17.
 */
define(function (require) {
    "use strict";
    var LE = require("app");
    var template = require("user-management-templates/skills/accountSettingsSLAOptionBubbleView.tmpl");
    var Settings = require("codeTables/settings.json");

    var AccountSettingsSLAOptionBubbleView = {};

    LE.module("LEUserManagement", function (LEUserManagement, LE, Backbone, Marionette, $, _) {
        AccountSettingsSLAOptionBubbleView = Marionette.ItemView.extend({
            template: template,
            ui: {},
            initialize: function(options) {

            },

            customTemplateHelpers: function() {
                var slaPerSkillSiteSettings =  LEUserManagement.getDataManager().getSiteSettingsSLA();
                var defaultResponseTimeUnit = slaPerSkillSiteSettings.get(Settings.SETTING_ID.DEFAULT_SLA_UNITS).getValue();
                var defaultResponseTime = slaPerSkillSiteSettings.get(Settings.SETTING_ID.DEFAULT_SLA_RESPONSE_TIME).getValue();
                var urgentResponseTimeUnit = slaPerSkillSiteSettings.get(Settings.SETTING_ID.URGENT_SLA_UNITS).getValue();
                var urgentResponseTime = slaPerSkillSiteSettings.get(Settings.SETTING_ID.URGENT_SLA_RESPONSE_TIME).getValue();
                var firstTimeResponseTimeUnit = slaPerSkillSiteSettings.get(Settings.SETTING_ID.FIRST_TIME_SLA_UNITS).getValue();
                var firstTimeResponseTime = slaPerSkillSiteSettings.get(Settings.SETTING_ID.FIRST_TIME_SLA_RESPONSE_TIME).getValue();

                var translatedDefaultResponseTimeUnit = LE.siteSettings.SlaUnitsSettings.getTranslatedSlaUnits(defaultResponseTimeUnit);
                var translatedUrgentResponseTimeUnit = LE.siteSettings.SlaUnitsSettings.getTranslatedSlaUnits(urgentResponseTimeUnit);
                var translatedFirstTimeResponseTimeUnit = LE.siteSettings.SlaUnitsSettings.getTranslatedSlaUnits(firstTimeResponseTimeUnit);

                return {
                    defaultValue: defaultResponseTime,
                    defaultUnit: translatedDefaultResponseTimeUnit,
                    urgentValue: urgentResponseTime,
                    urgentUnit: translatedUrgentResponseTimeUnit,
                    firstTimeValue: firstTimeResponseTime,
                    firstTimeUnit: translatedFirstTimeResponseTimeUnit
                };
            },
            onClose: function() {
                LEUserManagement.logger.debug("onClose", "AccountSettingsSLAOptionBubbleView:onClose");
            }
        });
    });
    return AccountSettingsSLAOptionBubbleView;
});
